import { UPDATE_STUDENT1_TAB, UPDATE_STUDENT2_TAB, UPDATE_NAVIGATION_CONFIG_TAB } from './types'
const initialState = {
    student1Tab:"",
    student2Tab:"",
    navigationConfigTab:""
};
const studentReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case UPDATE_STUDENT1_TAB:
            return {
                ...state,
                student1Tab: {...(state.student1Tab),...payload}

            };
        case UPDATE_STUDENT2_TAB:
            return {
                ...state,
                student2Tab: {...(state.student2Tab),...payload}

            };
        case UPDATE_NAVIGATION_CONFIG_TAB:
            return {
                ...state,
                navigationConfigTab: payload

            };
        default:
            return state;
    }
}
export default studentReducer
